import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";

const CustomTable = ({
  columns,
  data,
  isLoading = false,
  noDataMessage = "No data available",
  hideHeader = false,
  sx = {},
}) => {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: "8px",
        border: "1px solid #e2e8f0",
        ...sx,
      }}
    >
      <Table>
        {!hideHeader && (
          <TableHead sx={{ backgroundColor: "#f8fafc" }}>
            <TableRow>
              {columns.map((col, index) => (
                <TableCell
                  key={index}
                  sx={{
                    fontWeight: 600,
                    color: "#475569",
                    textTransform: "uppercase",
                    fontSize: "0.85rem",
                    letterSpacing: "0.05em",
                    ...(col.headerSx || {}),
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center" sx={{ py: 6 }}>
                <CircularProgress size={32} />
              </TableCell>
            </TableRow>
          ) : !data || data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                align="center"
                sx={{ py: 6, fontStyle: "italic", color: "#64748b" }}
              >
                {noDataMessage}
              </TableCell>
            </TableRow>
          ) : (
            data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  "&:last-child td, &:last-child th": { borderBottom: 0 }, 
                  "&:hover": {
                    backgroundColor: hideHeader ? "transparent" : "#f1f5f9",
                  },
                }}
              >
                {columns.map((col, colIndex) => (
                  <TableCell
                    key={colIndex}
                    sx={{
                      color: "#1e293b",
                      fontSize: "0.95rem",
                      fontWeight: 500,
                      ...(col.cellSx || {}),
                    }}
                  >
                    {col.render ? col.render(row, rowIndex) : row[col.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
